import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Slide from './Slide';

const mapStateToProps = (state, ownProps) => ({
    elements: _.filter(state.elements, ['slide_id', ownProps.slide.id]),
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Slide);
